module.exports = __webpack_public_path__ + "img/jichu.38ad106f.jpg";